import styled from 'styled-components'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {PlainLinkStyledButton} from '../../../../styledComponents/Button'
import {DisplayItemSelect, DisplayItemSelectIcon} from '../../../../styledComponents/DisplayItem'
import {StyledSelect} from '../../../../styledComponents/StyledTypeDefinitions'
import {backArrow, forwardArrow} from '../../../../styledComponents/Links'
import {RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {ExpandButton} from '../../../../components/reservations/components/CommonStyle'

export const MiddleFontBold = styled.span`
    font-size: ${FontSize.Middle};
    font-weight: bold;
`

export const BigFontBold = styled.span`
    font-size: ${FontSize.Big};
    font-weight: bold;
`

export const ExtraBigFontBold = styled.span`
    font-size: ${FontSize.ExtraBig};
    font-weight: bold;
`

export const StatusSpan = styled.span`
    font-size: ${FontSize.Middle};
    color: ${Colors.AccentDark};
`

export const Divider = styled.div<{ $color?: string }>`
    width: 100%;
    border-top: 1px solid ${({$color}) => ($color ? $color : Colors.Surface)}
`

export const StyledLink = styled(PlainLinkStyledButton)`
    position: relative;
    text-align: right;
    font-size: ${FontSize.Middle};
`

export const SelectIcon = styled(DisplayItemSelectIcon)`
    &:after {
        right: 15%;
    }
`

export const SelectArea: StyledSelect = styled(DisplayItemSelect)`
    width: 201px;
    height: 50px;
    font-size: ${FontSize.Body};
    margin: 5px 10px;
`

export const PlainLinkStyledBackButton = styled(PlainLinkStyledButton)`
    position: relative;
    padding-left: 15px;
    text-align: left;
    margin: 0;

    &:before {
        ${backArrow};
    }

    &:disabled {
        color: #ccc;
        cursor: default;
    }

    &:disabled::before {
        border-top-color: #ccc;
        border-left-color: #ccc;
    }
`

export const PlainForwardLinkStyledButton = styled(PlainLinkStyledButton)`
    position: relative;
    padding-right: 15px;
    text-align: right;
    margin: 0;

    &:after {
        ${forwardArrow};
    }

    &:disabled {
        color: #ccc;
        cursor: default;
    }

    &:disabled::after {
        border-top-color: #ccc;
        border-right-color: #ccc;
    }
`

export const Headline = styled(RowFlexContainer)`
    height: 31px;

    &:hover {
        cursor: pointer;
    }
`

export const SmallExpandButton = styled(ExpandButton)`
    transform: scale(0.7, 0.7);
`

export const WhiteArea = styled.div`
    background-color: ${Colors.Surface};
    ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `}
    padding: 10px 15px;
    box-sizing: border-box;
    word-break: normal;
    line-break: strict;
`

